import {formatBrandName} from "@/app/utils/Format";

export default function(brand) {
    return formatBrandName(brand)
}